import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BACKEND_URL } from '../config';

export default function useAuthCheck(setIsAuthenticated: (val: boolean) => void) {
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setIsAuthenticated(false);
      return;
    }

    fetch(`${BACKEND_URL}/api/admin`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (!res.ok) {
          localStorage.removeItem('token');
          localStorage.removeItem('admin');
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
      })
      .catch(() => {
        setIsAuthenticated(false);
      });
  }, [location, setIsAuthenticated]);
}
